'use client';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import type { ElasticRetailer } from '@//app/api/retailers/[slug]';
import { Link } from '@//components/Link';
import { useLegacyTrackOutboundLinkRetailer } from '@//data/tracking/useLegacyTrackOutboundLinkRetailer';
import styles from '../../RetailerPage.module.scss';

interface RetailerHomePageProps {
  retailer: ElasticRetailer;
}

const RetailerHomePage = ({ retailer }: RetailerHomePageProps) => {
  const tCommon = useTranslations('other.common');

  const { trackLegacyOutboundLinkRetailer } = useLegacyTrackOutboundLinkRetailer();

  const onClick = useCallback(
    () => trackLegacyOutboundLinkRetailer(retailer),
    [trackLegacyOutboundLinkRetailer, retailer],
  );

  if (!retailer.homePage) return null;

  return (
    <>
      <dt className={styles.descriptionListLabel}>{tCommon('website.label')}</dt>
      <dd className={styles.descriptionListValue}>
        <Link
          href={retailer.homePage}
          title={tCommon('website.linkAriaLabel', {
            website: retailer.homePage,
          })}
          onClick={onClick}
          target="_blank"
          rel="noopener noreferrer nofollow"
          prefetch="none"
        >
          {retailer.homePage}
        </Link>
      </dd>
    </>
  );
};

export default RetailerHomePage;
